<div class="mobile-list-wrapper">
  <ng-container *ngFor="let item of items; let index = index">
    <ng-container *ngTemplateOutlet="templateRef; context: {$implicit: item, index: index}"></ng-container>
  </ng-container>
  <ng-container *ngIf="items?.length === 0">
    <app-i18n [key]="'No data to display'"></app-i18n>
  </ng-container>
</div>
